{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.79.1",
	"hash": "93ef29c19e18031d15b1871551705c4e23d866aa"
}
